<template>
    <section>
        <div class="top__container"  v-if="fields">
                <div class="title">{{ fields['Banner title'] }} </div>
        </div>
        <div class="image-section">
          <video v-if="fields" :src="`${this.$store.state.base_directory}${fields['Banner Video'].replace(/^public\//, '')}`" class="factory-image" autoplay muted loop playsinline></video>
        </div>
        <div class="top__container bottom" v-if="fields">
          <div class="details" data-animate-group>
            <div class="detail-item" v-for="item in fields['Statistics on banner']" data-animate="slideUp">
              <div class="icon">
                <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
              </div>
              <div class="text" v-html="item.text">
              </div>
            </div>
          </div>
      </div>
    </section>
    </template>
    
    <script>
    export default {
      name: "ServicesSection",
      props: {
        fields: [Array,Object],
      },
    };
    </script>
    
    <style scoped>
    .top__container{
        display: flex;
        justify-content: center;
    }
    .top__container .title{
        /* Header/H1: 44px Medium */
        color: rgb(5, 5, 5);
        font-size: 44px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: center;
        max-width: 1034px;
        padding-bottom: 44px;
        padding-top: 88px;
    }
    .image-section{
      padding-top: 33.333% ;
      margin-bottom: 64px;
    }
  .wrapper__texts{
      position: relative;
      margin-bottom: 36px;
  }
  .wrapper__texts .low__text{
      color: rgb(85, 98, 114);
      font-size: 13px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      padding-bottom: 10px;
  }
  .wrapper__texts .text{
  /* Header/H1: 44px Medium */
      color: rgb(5, 5, 5);
      font-size: 44px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      max-width: 640px;
  }
  .wrapper__texts a{
      position: absolute;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      color: rgb(5, 5, 5);
      font-size: 16px;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
  }
  
  
  
    .services-container {
      font-family: Arial, sans-serif;
      padding: 20px;
      color: #333;
    }
    
    .header {
      text-align: center;
      margin-bottom: 20px;
    }
    
    .header span {
      text-transform: uppercase;
      font-size: 14px;
      color: #777;
    }
    
    .header h1 {
      font-size: 28px;
      margin: 10px 0;
      color: #000;
    }
    
    .learn-more {
      font-size: 14px;
      color: #007bff;
      text-decoration: none;
    }
    
    .learn-more:hover {
      text-decoration: underline;
    }
    
    .factory-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position:absolute;
      left: 0;
      top: 0;
    }
    
    .details {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 20px;
      width: 100%;
    }
    
    .detail-item {
      flex: 1 1 calc(50% - 20px);
      display: flex;
      flex-direction: column;
      max-width: 556px;
    }
    
    .icon {
      flex-shrink: 0;
      width: 56px;
      height: 56px;
      background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
    }
    
    .text {
  
    }
    .text p {
      color: rgb(5, 5, 5);
      font-size: 24px;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: left;
      padding-bottom: 28px;
    }
    .text p:last-child {
      padding-top: 32px;
      border-top: 1px solid rgb(222, 230, 234);
      padding-bottom: unset;
    }
    @media (max-width: 1024px) {
      .wrapper__texts a{
          bottom: unset;
          top: 0;
      }
      .top__container .title{
        font-size: 32px;
      }
      .wrapper__texts .text{
          font-size: 44px;
          max-width: 100%;
      }
      .details{
        flex-direction: column;
      }
      .detail-item {
        max-width: unset;
        width: 100%;
        flex: unset;
      }
      .image-section{
        padding-top: 40% ;
      }
  }
    /* Адаптивность */
    @media (max-width: 768px) {
      .details {
        flex-direction: column;
      }
      .top__container .title{
        font-size: 24px;
        padding-bottom: 16px;
        padding-top: 24px;
      }
      .detail-item {
        
      }
      .factory-image{
        min-height: 300px;
      }
      .header h1 {
        font-size: 24px;
      }
    
      .learn-more {
        font-size: 12px;
      }
      .image-section{
        padding-top: 50% ;
      }
      .detail-item {
        flex: 1 1 100%;
        flex-direction: row;
        gap: 12px;
      }
      .top__container.bottom{
        flex-direction: column;
      }
    }
    </style>